import { render, staticRenderFns } from "./EpmForm.vue?vue&type=template&id=4edbc0ae"
import script from "./EpmForm.vue?vue&type=script&lang=js"
export * from "./EpmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports